module.exports = __webpack_public_path__ + "img/white-x.16792e4f.svg";